import React from 'react';
import {Table as BaseTable} from 'desktop/sports/golf/players-list/classic';

class Table extends BaseTable {}

export {Table};
